import { render, staticRenderFns } from "./MasterOpd.vue?vue&type=template&id=2069fb4c&scoped=true"
import script from "./MasterOpd.vue?vue&type=script&lang=js"
export * from "./MasterOpd.vue?vue&type=script&lang=js"
import style0 from "./MasterOpd.vue?vue&type=style&index=0&id=2069fb4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069fb4c",
  null
  
)

export default component.exports